
import { defineComponent } from "vue";
import { Field } from "vee-validate";

export default defineComponent({
  name: "NumberInput",
  components: {
    Field,
  },
  props: {
    modelValue: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    replaceValue(val: string) {
      return val.replace(/[^0-9]/g, "");
    },
    onInput(event: Event): void {
      if (event.target instanceof HTMLInputElement) {
        event.target.value = event.target.value.replace(/[^0-9]/g, "");
        this.$emit("update:modelValue", event.target.value);
      }
    },
  },
  emits: ["update:modelValue"],
});
